import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { VivaInsightsCopySource } from 'app/model/pipeline/copysource/viva-insights.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(VivaInsightsCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts
    }
})
export class VivaInsightsCopySourceAdapter extends CopySourceAdapter<VivaInsightsCopySource, Model.VivaInsightsSource> {
    protected override async _toResource(copySource: VivaInsightsCopySource): Promise<Model.VivaInsightsSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(VivaInsightsCopySource).name);
    }

    protected override async _toModel(resource: Model.VivaInsightsSource, copyActivity: CopyActivity): Promise<VivaInsightsCopySource> {
        return this._toTabularModel(resource, copyActivity, VivaInsightsCopySource.MODEL);
    }
}
